import type { OrderCommunicationSubscription, OrderCommunicationSubscriptions } from '#domain/Subscription.ts';

import type { ApiSubscription, ApiSubscriptions } from '../notificationsApi.slice.ts';

export const mapSubscription = (subscription: ApiSubscription): OrderCommunicationSubscription => ({
    tourId: subscription.tour_id,
    eventType: subscription.event_type,
    importance: subscription.importance,
});

export const mapSubscriptions = (subscriptions: ApiSubscriptions): OrderCommunicationSubscriptions => ({
    items: subscriptions.items.map(mapSubscription),
});

export const mapSubscriptionToApi = (subscription: OrderCommunicationSubscription): ApiSubscription => ({
    tour_id: subscription.tourId,
    event_type: subscription.eventType,
    importance: subscription.importance,
});

export const mapSubscriptionsToApi = (subscriptions: OrderCommunicationSubscriptions): ApiSubscriptions => ({
    items: subscriptions.items.map(mapSubscriptionToApi),
});
